import React, { lazy, Suspense } from 'react';
import PropTypes from 'prop-types';
import { historyRoutes, clientProfileRoutes, CLIENT_PROFILE_COMPONENT_TYPES } from '@atlas/routing';

import ClientProfileSubRouter from '../ClientProfileSubRouter';

const { history } = clientProfileRoutes;

const BetHistoryPage = lazy(() =>
  import(/* webpackChunkName: "BetHistoryPage" */ 'common/History/BetHistory/BetHistory'),
);
const MyOrdersHistoryPage = lazy(() =>
  import(/* webpackChunkName: "History" */ 'common/History/MyOrders/MyOrdersHistoryPage'),
);
const CasinoHistory = lazy(() =>
  import(/* webpackChunkName: "CasinoHistory" */ 'common/History/Casino/CasinoHistory'),
);

const { betHistory, casinoHistory, myOrders } = historyRoutes;

const SuspensePage = Component => () => (
  <Suspense fallback={<div />}>
    <Component />
  </Suspense>
);

const getAvailableRoutes = clientProfilePath => ({
  [CLIENT_PROFILE_COMPONENT_TYPES.HISTORY_BET_HISTORY]: {
    path: `${clientProfilePath}/${history}/${betHistory}`,
    component: SuspensePage(BetHistoryPage),
  },
  [CLIENT_PROFILE_COMPONENT_TYPES.HISTORY_MY_ORDERS]: {
    path: `${clientProfilePath}/${history}/${myOrders}`,
    component: SuspensePage(MyOrdersHistoryPage),
  },
  [CLIENT_PROFILE_COMPONENT_TYPES.HISTORY_CASINO_HISTORY]: {
    path: `${clientProfilePath}/${history}/${casinoHistory}`,
    component: SuspensePage(CasinoHistory),
  },
});

const HistoryRouter = ({ historyTabs = [] }) => (
  <ClientProfileSubRouter
    tabs={historyTabs}
    getAvailableRoutes={getAvailableRoutes}
    parentRoute={history}
  />
);

HistoryRouter.propTypes = { historyTabs: PropTypes.array };

export default HistoryRouter;
